import { Close } from "@mui/icons-material";
import {
  Box,
  Stack,
  IconButton,
  Typography,
  Grid,
  Link,
  Button,
  CircularProgress,
} from "@mui/material";
import { CustomModel } from "@/components/Elements/custom-modal";
import openMail from "@/assets/closedMail.svg";
import OtpInput from "react-otp-input";
import { useState } from "react";
import { resendOTP, verifyOTPWithOTP } from "@/features/auth/api/verifyOTP";
import { useAuth } from "@/lib/auth";
import closeModal from "@/assets/closeModal.svg";
import { getTicketStatus } from "@/features/Tickets/api/getTicketStatus";
import storage from "@/utils/storage";
import { ticketListData } from "@/features/Tickets/types";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import { getWalletAmount } from "../Elements/api/getWalletamount";
interface verifyOTPProps {
  open: boolean;
  onClose: () => void;
  email: string;
  redirectPath: any;
}

type verifyOTPValues = {
  otp: "";
  email: "";
};

const initialValues: verifyOTPValues = {
  otp: "",
  email: "",
};
// add comment
const VerifyOTP = ({ open, onClose, email, redirectPath }: verifyOTPProps) => {
  console.log(redirectPath, "redirectPath");

  let valueData: Promise<ticketListData[]>;
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const { login, isLoggingIn } = useAuth();
  const [isVerifying, setIsVerifying] = useState(false);
  const [otpError, setOtpError] = useState("");
  console.log(isVerifying, "isklkslaklsk");
  const handleContinue = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setIsVerifying(true); // Start loader

    const data = { otp: otp, email: email };
    console.log(data, "data");

    try {
      const response = await login(data);
      if (storage.getToken()) {
        console.log("storage.getToken()", storage.getToken());
        const dataWallet = await getWalletAmount();
        console.log("ddd", dataWallet?.data?.walletAmount);
        if (dataWallet?.data?.walletAmount === 0) {
          navigate("/app/wallet/MyLottery", { replace: true });
        } else {
          let target = "/app";
          if (
            redirectPath &&
            typeof redirectPath === "object" &&
            "pathname" in redirectPath
          ) {
            target = redirectPath.pathname + (redirectPath.search || "");
          }
          console.log("target", target);
          navigate(target, { replace: true });
        }
      }
    } catch (err: any) {
      const message = err.response?.data?.message;
      setOtpError(message)
    } finally {
      setIsVerifying(false);
    }
  };
  const handleResend = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.stopPropagation();
    const data = { email: email };
    open = true;
    await resendOTP(data);
    open = true;
  };
const handleOtpChange = (value: string) => {
  setOtp(value);
  if (otpError) setOtpError(""); // Clear error on typing again
};
  return (
    <CustomModel
      open={open}
      onClose={onClose}
      childComponent={
        <>
          <Stack
            direction="column-reverse"
            alignItems={"end"}
            height="100%"
            sx={{ p: 2 }}
          >
            <Box
              sx={{
                width: "100%",
                overflow: "auto",
                my: { md: "50px", xs: "20px" },
              }}
              display="flex"
              flexDirection="column"
              alignItems="center"
            >
              <img
                src={openMail}
                alt="mailIcon"
                style={{ textAlign: "center", display: "block" }}
                width="60px"
                height="60px"
                className="image-otp"
              />

              <Typography
                component="h4"
                variant="h4"
                sx={{ mt: { md: "20px", xs: "7px" }, textAlign: "center" }}
              >
                Check your Email
              </Typography>
              <Typography
                component="h6"
                variant="h6"
                sx={{
                  textAlign: "center",
                  mt: { xs: "5px", md: "15px" },
                  mb: "20px",
                  ml: { xs: "15px", md: "0px" },
                }}
              >
                We sent a verification code to <br />{" "}
                <span style={{ color: "#FF9525" }}>{email}</span>
              </Typography>
              <OtpInput
                value={otp}
                onChange={handleOtpChange}
                numInputs={4}
                renderSeparator={<span style={{ marginRight: "10px" }}></span>}
                renderInput={(props) => (
                  <input
                    {...props}
                    type="number"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && otp.length === 4 && !isVerifying) {
                        handleContinue(e as any);
                      }
                    }}
                  />
                )}
                inputStyle={"input-otp"}
              />
              <Grid container marginTop={"20px"}>
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Button
                    variant="contained"
                    onClick={handleContinue}
                    sx={{
                      background: "linear-gradient(111deg, #ff9525, #ff5448)",
                      padding: {
                        xs: "10px 15px",
                        sm: "10px 30px",
                        md: "10px 50px",
                      },
                      minHeight: { xs: "auto", md: "52px" },
                      minWidth: { xs: "auto", md: "152px" },
                    }}
                    disabled={isVerifying} // Disable button while verifying
                  >
                    {isVerifying ? (
                      <CircularProgress size={24} color="inherit" /> // Show loader while verifying
                    ) : (
                      "Verify"
                    )}
                  </Button>
                </Grid>
              </Grid>
              {otpError && (
                <div style={{ color: "red", fontSize: "14px", marginTop: "8px" }}>
                  {otpError}
                </div>
              )}
            </Box>
            <Box sx={{ position: "relative" }}>
              <IconButton
                sx={{
                  padding: { md: "10px", xs: "10px" },
                  position: "absolute",
                  top: "0px",
                  right: "0px",
                }}
                onClick={onClose}
              >
                <img src={closeModal} alt="closeModal" />
              </IconButton>
            </Box>
          </Stack>
        </>
      }
    />
  );
};

export default VerifyOTP;
